import { Injectable } from '@angular/core';
import { ContactMail } from '../models/contactsMail.model';
import { ApiKeys } from '../config/config';
import { HttpServices } from './http.service';

@Injectable()
export class MailService {
    constructor(private httpService: HttpServices) { }

    sendContactMail(contactMail: ContactMail, extractData: (ret: any) => void) {
        return this.httpService.put<ContactMail, any>(ApiKeys.PUT_ENVOYER_MAIL, contactMail, extractData);
    }
}
